import { requestApi } from 'api/api'
import { NotificationDestination, NotificationEvent } from 'pages/ManageIntegrations/types'
import { WithPaginationApiResponse } from 'types/pagination'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'
import type { WebhooksRequestConfig } from 'hooks/useWebhooksBaseUrl'

export interface DestinationRequest extends WebhooksRequestConfig {
  search?: string
  size?: number
  page?: number
  sort?: string
}

export const getNotificationDestinations = ({
  search = '',
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  sort = '',
  baseUrl,
  apiPath,
  authenticated,
  config,
}: DestinationRequest): Promise<WithPaginationApiResponse<NotificationDestination[]>> => {
  return requestApi({
    url: `${apiPath}/destinations`,
    baseUrl,
    method: 'GET',
    authenticated,
    config,
    params: {
      pageSize: size,
      pageNumber: page,
      ...(sort && { sort }),
      ...(search && { name: search }),
    },
  })
}

export const getNotificationEvents = ({
  baseUrl,
  apiPath,
  authenticated,
  config,
}: WebhooksRequestConfig): Promise<NotificationEvent[]> => {
  return requestApi({
    url: `${apiPath}/events`,
    baseUrl,
    method: 'GET',
    authenticated,
    config,
  })
}

export interface DeleteNotificationDestinationRequest extends WebhooksRequestConfig {
  destinationId: string
}

export const deleteNotificationDestination = ({
  destinationId,
  baseUrl,
  apiPath,
  authenticated,
  config,
}: DeleteNotificationDestinationRequest) => {
  return requestApi({
    url: `${apiPath}/destinations/${destinationId}`,
    baseUrl,
    method: 'DELETE',
    authenticated,
    config,
  })
}

export interface PostNotificationDestinationsRequest extends WebhooksRequestConfig {
  url: string
  description: string
  type: string
  events: string[]
  signingMode: string
}

export interface UpdateNotificationDestinationRequest extends WebhooksRequestConfig {
  destinationId: string
  description: string
  events: string[]
}

export const postNotificationDestinations = ({
  url,
  description,
  type,
  events,
  signingMode,
  baseUrl,
  apiPath,
  authenticated,
  config,
}: PostNotificationDestinationsRequest): Promise<NotificationDestination> => {
  return requestApi({
    url: `${apiPath}/destinations`,
    baseUrl,
    method: 'POST',
    authenticated,
    config,
    data: { url, description, type, events, signingMode },
  })
}

export const updateNotificationDestination = ({
  destinationId,
  description,
  events,
  baseUrl,
  apiPathV2,
  authenticated,
  config,
}: UpdateNotificationDestinationRequest): Promise<NotificationDestination> => {
  return requestApi({
    url: `${apiPathV2}/destinations/${destinationId}`,
    baseUrl,
    method: 'PUT',
    authenticated,
    config,
    data: { description, events },
  })
}
